import { render, staticRenderFns } from "./InfoFuma.vue?vue&type=template&id=bb64c5b6"
import script from "./InfoFuma.vue?vue&type=script&lang=js"
export * from "./InfoFuma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports